import React, { useEffect, useState } from 'react';
import { Gift } from 'lucide-react';
import { loadSettings } from './CartShippingTeaser';
import { giftPromoStatus } from '../../lib/giftPromo';

// Progress toward the free-gift threshold; turns green once the basket qualifies.
export const CartGiftNudge = ({ totalPrice }) => {
  const [settings, setSettings] = useState(null);
  useEffect(() => { loadSettings().then(setSettings); }, []);

  const gift = settings ? giftPromoStatus(settings, totalPrice) : null;
  if (!gift) return null;

  return (
    <div
      className={`text-xs p-2.5 rounded-lg border ${gift.unlocked ? 'bg-green-50 border-green-300 text-green-800' : 'bg-amber-50 border-amber-200 text-amber-800'}`}
      data-testid={`cart-gift-nudge-${gift.unlocked ? 'unlocked' : 'locked'}`}
    >
      <p className="font-semibold flex items-center gap-1.5">
        <Gift className="w-3.5 h-3.5 shrink-0" />
        {gift.unlocked
          ? <>Unlocked: <span data-testid="cart-gift-name">{gift.giftName}</span> comes with this order!</>
          : <>Add <strong data-testid="cart-gift-gap">€{gift.gap.toFixed(2)}</strong> more to unlock {gift.giftName}</>}
      </p>
      <div className="mt-1.5 h-1.5 w-full rounded-full bg-white/70 overflow-hidden" aria-hidden="true">
        <div
          className={`h-full rounded-full transition-[width] duration-500 ${gift.unlocked ? 'bg-green-500' : 'bg-amber-500'}`}
          style={{ width: `${gift.progress}%` }}
        />
      </div>
      {!gift.unlocked && <p className="mt-1 opacity-80">Free gift on basket items of €{gift.threshold.toFixed(2)}+</p>}
    </div>
  );
};

export default CartGiftNudge;
